import React, { useState, useEffect , useRef } from 'react'
import G from '../../../../../../util/globalFunction'
import tremApi, { nullCheckParameter, nullExceptParameter } from '../../../../../../util/tremApi'

import ModalBox from '../../../../../../components/modalBox'
import { faLeaf } from '@fortawesome/free-solid-svg-icons'
import * as R from 'ramda'

export default props => {
    const { reservPopupProps, equipOperSpList = [], spChkData = [] } = props || {}

    //TODO : Build 할때 오류 pass 이렇게 프로그램 짜지마!!!!
    if (!reservPopupProps) {
        return <div>pass!!!</div>
    }

    const { open, param, handleClose } = reservPopupProps || {}
    const buttons = [
        {
            title: G.t('trem.lang.home.0047'),/* 예약 */
            className: 'red',
            handler: popupData => {
                if (popupData?.agree1 != 'Y') {
                    alert(G.t('trem.lang.home.0795')) //개인정보를 수집·이용에 동의해주세요.
                    agree1.focus()
                    return false
                }
                //G.confirm(G.t('trem.lang.home.0797')).then(success => { //예약하시겠습니까
                if(window.confirm(G.t('trem.lang.home.0797'))){
                        let reservSaveParam = param

                        reservSaveParam['SMS_FLAG'] = popupData.SEND_TYPE === 'SMS' ? 'Y' : 'N'
                        reservSaveParam['KAKAO_FLAG'] = (R.isNil(popupData.SEND_TYPE) || popupData.SEND_TYPE === 'KAKAO') ? 'Y' : 'N'
                        reservSaveParam['EMAIL_FLAG'] = 'Y'

                        const CHARGE_LIST = reservSaveParam.CHARGE_LIST
                        const MRO_LIST = reservSaveParam.MRO_LIST
                        delete reservSaveParam.CHARGE_LIST
                        delete reservSaveParam.MRO_LIST
                        delete reservSaveParam.OPT_MRO_LIST

                        CHARGE_LIST.map((v, i) => {
                            reservSaveParam[`CHARGE_LIST[${i}].TITLE`] = v.TITLE
                            reservSaveParam[`CHARGE_LIST[${i}].UOM`] = v.UOM
                            reservSaveParam[`CHARGE_LIST[${i}].USE_TIME`] = v.USE_TIME
                            reservSaveParam[`CHARGE_LIST[${i}].QUENTITY`] = v.QUENTITY
                            reservSaveParam[`CHARGE_LIST[${i}].REPEAT_AREA_COUNT`] = v.REPEAT_AREA_COUNT
                            reservSaveParam[`CHARGE_LIST[${i}].REPEAT_COUNT`] = v.REPEAT_COUNT
                            reservSaveParam[`CHARGE_LIST[${i}].COST`] = v.COST
                            reservSaveParam[`CHARGE_LIST[${i}].NET_PRICE`] = v.NET_PRICE
                            reservSaveParam[`CHARGE_LIST[${i}].DISCOUNT_TYPE`] = v.DISCOUNT_TYPE
                            reservSaveParam[`CHARGE_LIST[${i}].DISCOUNT_REF_SKEY`] = v.DISCOUNT_REF_SKEY
                            reservSaveParam[`CHARGE_LIST[${i}].DISCOUNT`] = v.DISCOUNT
                            reservSaveParam[`CHARGE_LIST[${i}].AMOUNT`] = v.AMOUNT
                            reservSaveParam[`CHARGE_LIST[${i}].DESCRIPTION`] = v.DESCRIPTION
                            reservSaveParam[`CHARGE_LIST[${i}].NOTE`] = v.NOTE
                        })
                        MRO_LIST.map((v, i) => {
                            reservSaveParam[`MRO_LIST[${i}].MRO_SKEY`] = v.MRO_SKEY
                            reservSaveParam[`MRO_LIST[${i}].UOM`] = v.UOM
                            reservSaveParam[`MRO_LIST[${i}].COST`] = v.COST
                            reservSaveParam[`MRO_LIST[${i}].QUENTITY`] = v.QUENTITY
                            reservSaveParam[`MRO_LIST[${i}].AMOUNT`] = v.AMOUNT
                            reservSaveParam[`MRO_LIST[${i}].NOTE`] = v.NOTE
                        })

                        //특수예약일때
                        equipOperSpList.length > 0 &&
                            spChkData.map((v, i) => {
                                reservSaveParam[`SP_LIST[${i}].OPER_SP_SKEY`] = v.OPER_SP_SKEY
                                reservSaveParam[`SP_LIST[${i}].RESERV_AREA_NO`] = v.RESERV_AREA_NO
                            })

                        //저장
                        tremApi(
                            '/r/hm/equipReservation/reservation/save',
                            nullExceptParameter(reservSaveParam)
                        )
                            .then(data => {
                                alert(G.t('trem.lang.home.0798')) //예약 신청이 완료되었습니다.
                                G.gotoPage(`/home/equip/reserv/list`)
                                
                            })
                            .catch(err => {
                                alert(G.t('trem.lang.home.0836')+'5', err)/* 오류발생5 */
                            })
                }
            },
        },
        {
            title: G.t('trem.lang.home.0146'),/* 닫기 */
            handler: handleClose,
        },
    ]

    const reservChargeProps = {
        params: param,
    }
    return (
        open && (
            <ModalBox {...reservPopupProps} buttons={buttons} width="800">
                <ReservCharge {...reservChargeProps} />
            </ModalBox>
        )
    )
}

const ReservCharge = props => {
    const { params, modalprops } = props || {}

    const { storedValue, setStoredValue } = modalprops || {}

    const CHARGE_LIST = params?.CHARGE_LIST || []

    const inputRef = useRef(null)
    const inputRefdiv = useRef([]);

    useEffect(() => {
        inputRefdiv.current[0].focus();
    }, [])

    //값 변경
    const handleChangeData = e => {
        if(e.charCode ===13){
            const param = { ...storedValue }
            if (e.target.type === 'checkbox') {
                param[e.target.name] ==='Y' ? (param[e.target.name] = 'N') : (param[e.target.name] = 'Y')
            } else { //radio 
                param[e.target.childNodes[0].name] = e.target.childNodes[0].value
            }
            setStoredValue(param)
        }else{
            const param = { ...storedValue }
            if (e.target.type === 'checkbox') {
                e.target.checked ? (param[e.target.name] = 'Y') : (param[e.target.name] = 'N')
            } else {
                param[e.target.name] = e.target.value
            }
            setStoredValue(param)
        }
    }
    return (
        <div tabIndex={0} ref={(val) => (inputRefdiv.current[0] = val)}>
            <h5 className="tt_type3">{G.t('trem.lang.home.0109')}</h5>{/* 요약 */}
            <div className="t_gray_box">
                <table className="table_type5">
                    <caption>요약 표 – 순번, 장비/서비스명, 수량, 청구단위, 단가, 할인율, 금액, 세액, 비고로 구성</caption>
                    <thead>
                        <tr>
                            <th scope="col">No.</th>
                            <th scope="col">{G.t('trem.lang.home.0110')}</th>{/* 장비/서비스명 */}
                            <th scope="col">{G.t('trem.lang.home.0111')}</th>{/* 수량 */}
                            <th scope="col">{G.t('trem.lang.home.0914')}<br/>{G.t('trem.lang.home.0114')}</th>{/* 청구 청구단위 */}
                            <th scope="col">{G.t('trem.lang.home.0100')}<br/>{G.t('trem.lang.home.0781')}</th>{/* 단가(원) */}
                            <th scope="col">{G.t('trem.lang.home.0068')}<br/>(%)</th>{/* 할인율(%) */}
                            <th scope="col">{G.t('trem.lang.home.0102')}<br/>{G.t('trem.lang.home.0782')}</th>{/* 금액(VAT별도) */}
                            <th scope="col">세액</th>
                            <th scope="col">{G.t('trem.lang.home.0074')}</th>{/* 비고 */}
                        </tr>
                    </thead>
                    <tbody>
                        {CHARGE_LIST.map((obj, index) => {
                            return (
                                <tr key={index}>
                                    <td>{index+1}</td>
                                    <td>{obj.TITLE}</td>
                                    <td>{obj.FINAL_UOM==="시간" ? obj.USE_TIME : obj.QUENTITY}</td> {/* 수량 */}{/*obj.QUENTITY*/}
                                    <td>{obj.FINAL_UOM}</td> {/* 단위 */}
                                    <td className="r">
                                    {
                                        obj.NOTE === "equip" &&
                                        params?.CHARGE_TYPE === '01' &&
                                        params?.TIME_UNIT != '1' &&
                                        params?.TIME_UNIT != '60'
                                        ? (obj?.COST *(60 / params?.TIME_UNIT) || 0).toLocaleString()
                                        : (obj?.COST).toLocaleString()
                                    }
                                    </td> {/* 단가 */}{/*{ (obj.COST || '').toLocaleString()}*/}
                                    <td>{obj.DISCOUNT_RATE}</td> {/* 할인율(%) */}
                                    <td className="r">{(obj.EXCEPT_TAX_AMOUNT || '').toLocaleString()}</td> {/* 금액(VAT별도) */}
                                    <td className="r">{(obj.TAX_AMOUNT || '').toLocaleString()}</td> {/* 세액 */}
                                    <td>{obj.DESCRIPTION}</td> {/* 비고 */}
                                </tr>
                            )
                        })}
                    </tbody>
                </table>
            </div>
            <div className="mb-5">
                <p className="t_reference">
                    <span className="mr-4">
                        {G.t('trem.lang.home.0118')} : {G.t('trem.lang.home.0119')} 10% {/* 부가세유형 : 부가세 10% */}
                    </span>
                    <span>
                        {G.t('trem.lang.home.0121')} :{' '}{/* 총금액 :  */}
                        {(Math.floor(params.AMOUNT + params.AMOUNT * 0.1) || '').toLocaleString()}
                    </span>
                    <span>
                        {' '}
                        ( {(params.AMOUNT || '').toLocaleString()} +{' '}
                        {(Math.floor(params.AMOUNT * 0.1) || '').toLocaleString()} ){' '}
                        {G.t('trem.lang.home.0122')}{/* VAT 포함 */}
                    </span>
                </p>
            </div>
            <div>
                <div>
                    <ul>
                        <li>
                            <table className="table_type2">
                                <caption className="hidden">
                                    <strong>{G.t('trem.lang.home.0799')}</strong> {/*개인정보 보호책임자 */}
                                    <p>{G.t('trem.lang.home.0800')}</p>{/* 이 표는 개인정보 보호책임자에 대하여 구분별 성명, 직책, 직급, 연락처로 안내합니다. */}
                                </caption>
                                <thead>
                                    <tr style={{ width: '100%', float: 'none' }}>
                                        <th scope="col" className="text-center" style={{ width: '100%' }}>
                                            {G.t('trem.lang.home.0801')} {/* 개인정보 수집 및 이용 동의 */}
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr style={{ width: '100%' }}>
                                        <td className="text-left" style={{ width: '100%' }}>
                                            <p className="tt_type5">{G.t('trem.lang.home.0123')}</p>{/* 필수항목 */}
                                            <p className="ml-3">
                                                ○서울바이오허브는 공용 연구시설 및 장비와 관련한 이용지원 서비스 제공을 위한 개인정보를 아래와 같이 아래와 같<br/>&nbsp;&nbsp;&nbsp;&nbsp;이 수집ㆍ이용하고 있습니다.<br/>
                                                1. 개인정보 수집 주체: 서울바이오허브<br/>
                                                2. 개인정보 이용 목적: 서울바이오허브 공용 연구시설 장비 운영/관리(범죄예방·증거확보·시설안전·화재방재·재난감시<br/>&nbsp;&nbsp;&nbsp;&nbsp;및 시설보호 등)<br/>
                                                3. 개인정보 수집 항목: ①성명 ②이메일 ③(휴대)전화번호 ④소속기관 ⑤부서 ⑥직위 ⑦화상 정보 ⑧출입기록<br/>
                                                4. 개인정보 보유 및 이용기간: 최대 90일
											</p>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                            <span style={{ fontSize: '13px' }}>{G.t('trem.lang.home.0131')}</span>{/* ※ 위의 개인정보 수집·이용에 대한 동의를 거부할 권리가 있습니다. 그러나 동의를 거부할 경우 장비 예약·이용이 불가합니다. */}
                        </li>
                    </ul>
                </div>
                <p className="check mb-6">
                    <input
                        title="선택"
                        type="checkbox"
                        name="agree1"
                        id="agree1"
                        className="check_type1"
                        ref={inputRef}
                        checked={'Y' === storedValue?.agree1}
                        onChange={handleChangeData}
                        onKeyPress={handleChangeData}
                    />
                    <label htmlFor="agree1">{G.t('trem.lang.home.0132')}</label>{/* 위와 같이 개인정보를 수집·이용하는데 동의하십니까? (필수) */}
                </p>
            </div>
            <div className="text_box3" style={{ marginBottom: 0 }}>
                <p>
                    {G.t('trem.lang.home.0141')}
                    {/* ※ 핸드폰번호 형식이 부정확할 경우 장비예약 진행 현황 관련 알림이 발송되지 않을 수 있습니다. */}
                </p>
                <p>
                    {G.t('trem.lang.home.0142')}
                    {/* ※ 장비예약 진행 현황 관련 알림 수신 방법을 선택해주세요. */}
                </p>
                <p>
                    {G.t('trem.lang.home.0143')}
                    {/* ※ 메일은 기본적으로 발송됩니다. */}
                </p>
                <div className="e_option mt-2" role="group" style={{ marginBottom: 0 }}>
                    <span tabIndex={0} aria-checked={'SMS' === storedValue?.SEND_TYPE} onChange={G.radioHandleClick} role="checkbox" onKeyPress={handleChangeData}>
                        <input
                            title="선택"
                            type="radio"
                            name="SEND_TYPE"
                            id="SEND_TYPE1"
                            value="SMS"
                            checked ={'SMS' === storedValue?.SEND_TYPE}
                            onChange={handleChangeData}
                        />
                        <label htmlFor="SEND_TYPE1">{G.t('trem.lang.home.0144')}</label>{/* 문자알림 */}
                    </span>
                     <span tabIndex={0} aria-checked={'KAKAO' === storedValue?.SEND_TYPE} onChange={G.radioHandleClick} role="checkbox" onKeyPress={handleChangeData}>
                        <input
                            title="선택"
                            type="radio"
                            name="SEND_TYPE"
                            id="SEND_TYPE2"
                            value="KAKAO"
                            checked={ R.isNil(storedValue?.SEND_TYPE) === true ||'KAKAO' === storedValue?.SEND_TYPE ? true:false}
                            onChange={handleChangeData}
                        />
                        <label htmlFor="SEND_TYPE2">{G.t('trem.lang.home.0145')}</label>{/* 카카오톡 알림*/}
                    </span>
                </div>
            </div>
        </div>
    )
}
